import React from 'react'

function ImageWrapper({image}) {
  return (
    <div className='background-secondary rounded-circle m-auto d-flex mt-4' style={{width: "100px", height: "100px"}}>
      <img src={image} alt="icon" className='m-auto align-self-center'/>
    </div>
  )
}

export default ImageWrapper